<script lang="ts">
  import ChevronsUpDown from '@lucide/svelte/icons/chevrons-up-down'
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu/index.js'
  import { Input } from '$lib/components/ui/input/index.js'
  import LibraryHeaderBox from './LibraryHeaderBox.svelte'
  import LibraryHeaderCollapsed from './LibraryHeaderCollapsed.svelte'

  let {
    formats,
    genres,
    years,
    tags,
    handleSelection,
    search = $bindable(),
    selectedGenres = $bindable([] as string[]),
    selectedStatus = $bindable([] as string[]),
    selectedYears = $bindable([] as string[]),
    selectedFormats = $bindable([] as string[]),
    selectedTags = $bindable([] as string[]),
  } = $props()

  let sortMethod = $state('title')
  let maxWidth = $state(0)

  function closeAndFocusTrigger() {}

  const visibleTabsCount = $derived(Math.floor(maxWidth / 300))

  const chip =
    'rounded-md border border-latte-surface1/60 bg-latte-mantle/45 px-2.5 py-1.5 shadow-sm backdrop-blur-sm dark:border-macchiato-surface1/60 dark:bg-macchiato-mantle/45'
</script>

<div class="w-full h-0" bind:clientWidth={null, (v) => (maxWidth = v!)}></div>

<div class="mt-24 mx-4 mb-3 flex flex-wrap items-end gap-2 sm:mx-10">
  <div class="{chip} flex min-w-0 flex-col gap-0.5">
    <span class="text-[8px] leading-none font-light text-latte-green dark:text-macchiato-green">
      search
    </span>
    <Input
      class="h-8 w-[140px] border-0 bg-transparent px-0 shadow-none focus-visible:ring-0 sm:w-[240px] text-latte-text dark:text-macchiato-text"
      bind:value={search}
      placeholder="Find series…"
    />
  </div>

  <LibraryHeaderBox
    show={visibleTabsCount >= 2}
    options={genres}
    optionKind="genre"
    bind:values={selectedGenres}
    {closeAndFocusTrigger}
    {handleSelection}
  />
  <LibraryHeaderBox
    show={visibleTabsCount >= 3}
    options={['new', 'nsfw']}
    optionKind="status"
    bind:values={selectedStatus}
    {closeAndFocusTrigger}
    {handleSelection}
  />
  <LibraryHeaderBox
    show={visibleTabsCount >= 4}
    options={years}
    optionKind="year"
    bind:values={selectedYears}
    {closeAndFocusTrigger}
    {handleSelection}
  />
  <LibraryHeaderBox
    show={visibleTabsCount >= 5}
    options={formats}
    optionKind="format"
    bind:values={selectedFormats}
    {closeAndFocusTrigger}
    {handleSelection}
  />
  <LibraryHeaderBox
    show={visibleTabsCount >= 6}
    options={tags}
    optionKind="tag"
    bind:values={selectedTags}
    {closeAndFocusTrigger}
    {handleSelection}
  />

  {#if visibleTabsCount < 6}
    <LibraryHeaderCollapsed
      {visibleTabsCount}
      {closeAndFocusTrigger}
      {handleSelection}
      {genres}
      {years}
      {formats}
      {tags}
      bind:selectedGenres
      bind:selectedStatus
      bind:selectedYears
      bind:selectedFormats
      bind:selectedTags
    />
  {/if}

  <div class="{chip} ml-auto flex flex-col gap-0.5">
    <span class="text-[8px] leading-none font-light text-latte-surface1 dark:text-macchiato-surface1">
      sort
    </span>
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        class="flex h-8 items-center gap-1 text-latte-text/80 transition-colors hover:text-latte-mauve dark:text-macchiato-text/80 dark:hover:text-macchiato-mauve"
      >
        <span class="text-sm leading-tight">
          {sortMethod.charAt(0).toUpperCase() + sortMethod.slice(1)}
        </span>
        <ChevronsUpDown class="size-3.5 opacity-60" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        class="border-latte-surface1/60 bg-latte-mantle dark:border-macchiato-surface1/60 dark:bg-macchiato-mantle"
      >
        <DropdownMenu.Item onclick={() => (sortMethod = 'title')}>Title</DropdownMenu.Item>
        <DropdownMenu.Item onclick={() => (sortMethod = 'release Date')}>
          Release Date
        </DropdownMenu.Item>
        <DropdownMenu.Item onclick={() => (sortMethod = 'score')}>Score</DropdownMenu.Item>
        <DropdownMenu.Item onclick={() => (sortMethod = 'added')}>Added</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  </div>
</div>
